import { getIsMobile } from '@bridebook/web/app-basic/lib/app/selectors';
import getFacetFilterUrl from '@bridebook/web/app-basic/lib/search/get-facet-filter-url';
import {
  getAreaFacets,
  getSearchFields,
  getSearchParams,
} from '@bridebook/web/app-basic/lib/search/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import getFacetFilters, {
  FacetFilterKey,
} from '@bridebook/web/app-shared/lib/search/quick-filter-texts';
import SearchFacetsPill from './search-facets-pill';
import { FC } from 'react';

const SearchFacets: FC = () => {
  const market = useMarket();
  const isMobile = useSelector(getIsMobile);
  const searchParams = useSelector(getSearchParams);
  const areaFacets = useSelector(getAreaFacets);
  const searchFields = useSelector(getSearchFields);

  const areaFacetsKeys = Object.keys(areaFacets || {});

  if (areaFacetsKeys.length == 0 || !searchParams || !searchFields) {
    return null;
  }

  const filters = getFacetFilters(areaFacetsKeys as FacetFilterKey[], true);
  const activeFilterIndex = filters.findIndex((filter) =>
    Object.keys(searchFields).includes(filter.key),
  );

  const pills = (
    <>
      {activeFilterIndex >= 0 && (
        <SearchFacetsPill
          href={getFacetFilterUrl(market.prefix, searchParams, filters[activeFilterIndex].key)}
          isSelected
          label={filters[activeFilterIndex].label}
          key={filters[activeFilterIndex].key}
        />
      )}
      {filters.map((filter, index) => {
        if (index === activeFilterIndex) return;
        return (
          <SearchFacetsPill
            href={getFacetFilterUrl(market.prefix, searchParams, filter.key)}
            label={filter.label}
            key={filter.key}
          />
        );
      })}
    </>
  );

  return <div className={isMobile ? 'bsfacets' : 'bsfacets-desktop'}>{pills}</div>;
};

export default SearchFacets;
